import useBannerAlert from '@/common/hooks/useBannerAlert.tsx';
import { Box, Group, Text } from '@mantine/core';
import { InfoIcon, WarningIcon, XCircleIcon } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

export default function BannerAlert({
  height,
  enabled = true,
}: {
  height: number;
  enabled?: boolean;
}) {
  const bannerAlert = useBannerAlert({ enabled });

  const severityIcon = (): ReactNode => {
    if (bannerAlert.severity === 'WARNING') {
      return <WarningIcon size={16} weight="fill" color="var(--mantine-color-yellow-4)" />;
    }

    if (bannerAlert.severity === 'ERROR') {
      return <XCircleIcon size={16} weight="fill" color="var(--mantine-color-red-4)" />;
    }

    return <InfoIcon size={16} weight="fill" color="var(--mantine-color-blue-4)" />;
  };

  return (
    bannerAlert.active && (
      <Box
        role={bannerAlert.severity === 'ERROR' ? 'alert' : 'status'}
        style={{
          height,
          backgroundColor: 'var(--mantine-color-dark-8)',
          color: 'var(--mantine-color-gray-0)',
        }}
      >
        <Group h="100%" gap={8} px="xs" wrap="nowrap" style={{ minWidth: 0 }}>
          <Box aria-hidden="true" display="flex" style={{ flex: '0 0 auto' }}>
            {severityIcon()}
          </Box>
          <Text fw={700} truncate title={bannerAlert.message} style={{ minWidth: 0 }}>
            {bannerAlert.message}
          </Text>
        </Group>
      </Box>
    )
  );
}
